import styled from 'styled-components';

import { stackedOnMobile } from '../common/Columns.styled';

/** Open answers have no aggregate of their own, so their expanded view is two columns. */
export const TwoColumns = styled.div(({ theme: { size } }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 2fr)',
  gridTemplateRows: 'minmax(0, 1fr)',
  gap: size.units(4),
  flex: 1,
  minHeight: 0,

  ...stackedOnMobile,
}));
